import { render, staticRenderFns } from "./UndangPenilitiKeamanan.vue?vue&type=template&id=2fc00110&scoped=true&"
import script from "./UndangPenilitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./UndangPenilitiKeamanan.vue?vue&type=script&lang=js&"
import style0 from "./UndangPenilitiKeamanan.vue?vue&type=style&index=0&id=2fc00110&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc00110",
  null
  
)

export default component.exports